export default __webpack_public_path__ + "static/media/overtime.65493f30.svg";